export default {"src":"/_next/static/media/delete.20cf4634.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};